import { MODULE_ROLES } from "./module-base.js";
/**
 * VSM role names — currently exactly the shared base. The layer exists so a
 * future VSM-specific role is a one-line append here without touching other
 * modules.
 *
 * The 6 methodology roles (VSM-WS RBAC, OQ-R1) are a separate authorization
 * decision; ship the base `owner|collaborator|viewer` union now. Facilitator is
 * deliberately NOT a role (Authorization & Collaboration Model v2): it is a
 * persistent, owner-granted privilege OVERLAY, never a role/enum/wire value. Do
 * not add it to this tuple.
 */
export const VSM_ROLES = [...MODULE_ROLES];
//# sourceMappingURL=vsm-membership.js.map